import { DrawingEdge } from '~/core/models';

export enum CustomSideType {
  RADIUS_OUT = 'RadiusOut',
  BUMP_OUT = 'BumpOut',
  REMOVE_CUSTOM_SIDE = 'RemoveCustomSide',
}

export const isBumpOut = (edge: DrawingEdge): boolean =>
  edge?.customSideType === CustomSideType.BUMP_OUT;

export const isRadiusOut = (edge: DrawingEdge): boolean =>
  edge?.customSideType === CustomSideType.RADIUS_OUT;
